module.exports = __webpack_public_path__ + "img/SAWBO_Logo_500px.jpg";